// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"527":"32fbaecf","770":"7d1b3f04","787":"8cf52469","788":"8621194e"}[chunkId] + ".chunk.js";
};